<template>

<div>

    <h1>Create new accommodation</h1>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="createAccommodation">

        <AccommodationFields/>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Create accommodation</button>
          </div>
        </div>

      </form>

    </div>

</div>

</template>

<script>
import AccommodationFields from '@/components/AccommodationFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'AccommodationCreate',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      accommodation: {},
      errors: null
    }
  },
  components: {
    AccommodationFields,
    Errors
  },
  methods: {
    createAccommodation () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'accommodation', {
        method: 'POST',
        body: JSON.stringify(this.accommodation),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          this.$router.push({ name: 'accommodation-edit', params: { id: response.data.id }})
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
